import React from 'react';
import ReactDOM from 'react-dom/client';
import { inject } from '@vercel/analytics';
import './styles/tokens.css';
import App from './App';

inject();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);